import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import { GET_SUBVENDOR_LIST, GET_SUBVENDOR_DETAILS, GET_ADDSUBVENDOR, GET_UPDATESUBVENDOR} from "resources/actionTypes";
import { addSubVendorApi, detailSubVendorApi, subVendorApi, updateSubVendorApi } from "services/SubVendorService";
import { getSubVendor } from "redux/actions/UserSubVendor";
import store from "redux/store";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchSubVendor(action) {
  try {
    const payload = action.payload || {}
    const userSubVendor = yield call(subVendorApi, payload);
    yield put({ type: GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_SUCCESS, userSubVendor: userSubVendor });
  } catch (e) {
    yield put({ type: GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_FAILED, message: e.message });
  }
}

export function* subVendorSaga() {
  yield takeEvery(GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_REQUESTED, fetchSubVendor);
}

function* fetchSubAddVendor(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userAddSubVendor = yield call(addSubVendorApi, payload.userAddSubVendor);
  if(userAddSubVendor.success){
    yield put({ type: GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_SUCCESS, userAddSubVendor: userAddSubVendor });
    toast.success(userAddSubVendor.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getSubVendor({id: payload.userAddSubVendor.vendorId, status:'', page:"", pageSize:""}));
  }else{
    yield put({ type: GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_FAILED, message: userAddSubVendor.message });
    store.dispatch(onLoaderTrigger(false));
      toast.error(userAddSubVendor.message || 'Add Sub-Vendor failed');
   
  }
}
export function* addSubVendorSaga() {
  yield takeEvery(GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_REQUESTED, fetchSubAddVendor);

}

function* fetchUpdateSubVendor(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userUpdateSubVendor = yield call(updateSubVendorApi, payload.userUpdateSubVendor);
  if(userUpdateSubVendor.success){
    yield put({ type: GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_SUCCESS, userUpdateSubVendor: userUpdateSubVendor });
    toast.success(userUpdateSubVendor?.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateSubVendor?.id){
      store.dispatch(getSubVendor({id: payload.userUpdateSubVendor.id, status:'', page:payload?.userUpdateSubVendor?.page, pageSize:payload?.userUpdateSubVendor?.pageSize,search:payload?.userUpdateSubVendor?.search}));
    }else{
      store.dispatch(getSubVendor({subVendorId: payload.userUpdateSubVendor.subVendorId, status:'', page:payload?.userUpdateSubVendor?.page, pageSize:payload?.userUpdateSubVendor?.pageSize,search:payload?.userUpdateSubVendor?.search}));
    }
  }else{
    yield put({ type: GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_FAILED, message: userUpdateSubVendor.message });
    store.dispatch(onLoaderTrigger(false));
      toast.error(userUpdateSubVendor?.message || 'Updating Sub-Vendor failed');
   
  }
}
export function* updateSubVendorSaga() {
  yield takeEvery(GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_REQUESTED, fetchUpdateSubVendor);

}

function* fetchDetailSubVendor(action) {
  try {
    const payload = action.payload || {}
    const userDetailSubVendor = yield call(detailSubVendorApi, payload);
    yield put({ type: GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_SUCCESS, userDetailSubVendor: userDetailSubVendor });
  } catch (e) {
    yield put({ type: GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_FAILED, message: e.message });
  }
}

export function* detailSubVendorSaga() {
  yield takeEvery(GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_REQUESTED, fetchDetailSubVendor);
}
